import { Button, Center, Flex, Group, Modal, Text, Title } from "@mantine/core";

import { useTranslation } from "react-i18next";

interface Props {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const ConfirmDelete = ({ isOpen, onClose, onDelete, title }: Props) => {
  const { t } = useTranslation();
  return (
    <Modal
      zIndex={302}
      opened={isOpen}
      onClose={onClose}
      size="md"
      padding={16}
      centered
      title={t("confirm_delete")}
    >
      <Text style={{ fontSize: "18px" }}>{title}</Text>
      <Group mt="lg" justify="flex-end">
        <Button onClick={onClose} variant="default">
          {t("cancel")}
        </Button>
        <Button
          onClick={() => {
            onDelete();
            onClose();
          }}
          color="red"
        >
          {t("delete")}
        </Button>
      </Group>
    </Modal>
  );
};

export default ConfirmDelete;
